import { MixpanelEvent, trackEvent } from "../../../analytics/mixpanel";
import { paymentBaseURL } from "../../../constants";
import { useAppSelector } from "../../../hooks/store-hooks";

const BecomeMemberButton = ({
  text,
  buttonCustomClass,
}: {
  text?: string;
  buttonCustomClass?: string;
}) => {
  const { homeData } = useAppSelector((state) => state.home);
  const user = homeData?.user;
  return (
    <a
      href={
        paymentBaseURL +
        `?email=${user?.email}&phone=${"%2B" + user?.phone}&first_name=${user?.first_name}&last_name=${user?.last_name}`
      }
      target="_blank"
    >
      <button
        className={
          buttonCustomClass ||
          "h-16 px-48 py-3.5 bg-secondary-300 rounded-xl shadow-inner text-white text-md font-bold font-['SF Pro'] leading-tight"
        }
        onClick={() => {
          if (text) {
            trackEvent(MixpanelEvent.BUTTON_PRESSED, {
              button_name: "membership_page_buy_button_press",
            });
          }
        }}
      >
        {text || "Become a member"}
      </button>
    </a>
  );
};
export default BecomeMemberButton;
